export * from './remito-acopio-selector-autocomplete-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remito-acopio-selector-autocomplete-dialog/index.ts